export const Logo = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "text-xl",
    default: "text-2xl md:text-3xl",
    large: "text-3xl md:text-4xl lg:text-5xl"
  };

  return (
    <div className={`font-heading flex items-center gap-3 ${sizeClasses[size]} ${className}`}>
      {/* Shield Icon with blue neon */}
      <svg 
        className={`${size === 'small' ? 'w-6 h-6' : size === 'large' ? 'w-10 h-10' : 'w-8 h-8'}`}
        viewBox="0 0 40 45" 
        fill="none"
      >
        <path 
          d="M20 2 L38 7 L38 25 Q38 36 20 43 Q2 36 2 25 L2 7 Z" 
          stroke="#00D4FF" 
          strokeWidth="1.5" 
          fill="none"
        />
        <line x1="20" y1="12" x2="20" y2="32" stroke="#00D4FF" strokeWidth="1.5"/>
        <line x1="10" y1="17" x2="30" y2="17" stroke="#00D4FF" strokeWidth="1.5"/>
        <circle cx="10" cy="22" r="3" fill="none" stroke="#00D4FF" strokeWidth="1"/>
        <circle cx="30" cy="22" r="3" fill="none" stroke="#00D4FF" strokeWidth="1"/>
      </svg>
      <div>
        <span className="font-bold text-[#00D4FF]">FORTUNATO</span>
        <span className="font-light text-white ml-2">LEGISLAI</span>
      </div>
    </div>
  );
};

export default Logo;
